import React from 'react';
import {
    DataGridPro,
    GridActionsCellItem,
} from '@mui/x-data-grid-pro';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinearProgress from '@mui/material/LinearProgress';
import {QuickSearchToolbar} from 'Components/DataGrid/Toolbars';
import { useTheme } from '@emotion/react';
import NorthWestIcon from '@mui/icons-material/NorthWest';
import config from 'config/config';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Checkbox } from '@mui/material';

export default function BundleCardList({ cardList, onRemoveCard, onEditCard, onUpdateRowPosition, onUpdateBundleSubscriptionStatus }) {
    // const [productList, setProductList] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const theme = useTheme();

    // React.useEffect(() => {
    //     (async () => {
    //         setIsLoading(true);
    //         const data = await fetchProductList();
    //         setProductList(data);
    //         setIsLoading(false);
    //     })();
    // }, []);

    function subscriptionStatusIcon(row, subType) {
        const sub = row.subscriptionMap?.find((s) => s.subscriptionTierCode === subType);
        let color = 'primary';
        if (sub.discount > 0) {
            color = theme.palette.amazingco.pink;
            console.log({ color });
        } else { 
            color = theme.palette.amazingco.text;
        }
        return (
            <Checkbox
            checked={!!sub?.isAvailable}
            style={{ color }}
            onChange={() => onUpdateBundleSubscriptionStatus(row.cardId, subType, !sub.isAvailable)}
          />
  
        )
    }

    function previewCard(card) {
        let url = '';
        if (card.cardType === 'PRODUCT') {
            url = config.productUIURL + '/' + card.cardData?.presentation?.urls?.join('/');
        }
        if (card.cardType === 'MICROEXPERIENCE') {
            url = config.eeeUrl + '/?microexperienceId=' + card.cardId;
        }
        if (url) {
            window.open(url);
        }
    }

    function deleteCard(card) {
        setIsLoading(true);
        onRemoveCard(card);
        setIsLoading(false);
    }

    function editCard(card) {
        setIsLoading(true);
        onEditCard(card);
        setIsLoading(false);
    }

    const columns = [
        {
            field: 'thumbnail',
            headerName: '',
            width: 50,
            valueGetter: (params) => params.row.cardImage.thumbnailUrl,
            renderCell: (params) => <img alt="thumbnail" src={params.value} style={{ width: 30, height: 30 }} />,
        },

        {
            field: 'cardId',
            headerName: 'ID',
            flex: 1,
        },
        {
            field: 'cardName',
            headerName: 'Name',
            flex: 1,
        },
        {
            field: 'cardType',
            headerName: 'Type',
            width: 200,
            valueFormatter : params => titleCase(params.value|| '')
        },
        {
            field: 'contentType',
            headerName: 'Content Type',
            width: 200,
            valueGetter : (params) => {
                console.log(params)
                switch (params.row?.cardType) {
                    case 'PRODUCT':
                        return titleCase(params.row?.cardData?.category || 'PRODUCT');
                    case 'MICROEXPERIENCE':
                        return titleCase(params.row?.cardData?.contentType || '');
                    default:
                        return '-'
                }
            }
        },
        {
            field: 'assignedFree',
            headerName: 'Free',
            renderCell: (params) => subscriptionStatusIcon(params.row, 'FREE'),
        },
        {
            field: 'assignedStandard',
            headerName: 'Standard',
            renderCell: (params) => subscriptionStatusIcon(params.row, 'STANDARD'),
        },
        {
            field: 'assignedPremium',
            headerName: 'Premium',
            renderCell: (params) => subscriptionStatusIcon(params.row, 'PREMIUM'),
        },
        {
            field: 'actions',
            type: 'actions',
            getActions: (params) => [
                <GridActionsCellItem
                    icon={params.row.cardType === 'PRODUCT' ? <NorthWestIcon /> : <VisibilityIcon />}
                    onClick={() => previewCard(params.row)}
                    label="Preview"
                />,
                <GridActionsCellItem icon={<EditIcon />} onClick={() => editCard(params.row)} label="Edit" />,
                <GridActionsCellItem
                    icon={<DeleteIcon />}
                    onClick={() => deleteCard(params.row)}
                    label="Remove"
                    showInMenu
                />,
            ],
        },
    ];

    const handleRowOrderChange = async (params) => {
        setIsLoading(true);

        await onUpdateRowPosition(params.oldIndex, params.targetIndex, cardList);
        setIsLoading(false);
    };

    return (
        <DataGridPro
            loading={isLoading}
            rows={cardList}
            columns={columns}
            pagination={true}
            pageSize={10}
            components={{ Toolbar: QuickSearchToolbar, LoadingOverlay: LinearProgress }}
            getRowId={(row) => row.sequenceNumber}
            rowReordering
            onRowOrderChange={handleRowOrderChange}
            sx={{
                height: '800px',
                '.MuiDataGrid-columnHeaders': {
                    fontWeight: 'bold',
                    fontSize: 14,
                    color: 'rgb(0,0,0)',
                    backgroundColor: 'rgb(244,246,248)',
                },
                '.MuiTablePagination-selectLabel': {
                    marginBottom: '0px',
                },
                '.MuiTablePagination-displayedRows': {
                    marginBottom: '0px',
                },
                '.MuiPaper-root.div.span': {
                    color: 'blue',
                },
            }}
        />
    );
}


function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }
 